/**
 * @typedef CommonSettingState
 * @property {CommonSetting}                data
 */

/**
 * @param {CommonSettingState|undefined}    state
 * @returns {CommonSettingState}
 */
export function initCommonSettingState(state = {}) {
    return {
        ...state,

        data: state?.data || initCommonSetting(),
    };
}

/**
 * @typedef CommonSetting
 *
 * @property {string}                       _id
 *
 * @property {ChatPromptAlert[]}            chatPromptAlerts
 * @property {ChatPromptGroup[]}            chatPromptGroups
 * @property {CommonSetting__OpenAI}        openai
 */

/**
 * @param {CommonSetting|undefined} state
 * @returns {CommonSetting}
 */
export function initCommonSetting(state = {}) {
    return {
        ...(state || {}),

        chatPromptAlerts: [...(state?.chatPromptAlerts || [])].map(initChatPromptAlert),
        chatPromptGroups: [...(state?.chatPromptGroups || [])].map(initChatPromptGroup),
        openai: initSetting__OpenAI(state?.openai),
    };
}

/**
 * @typedef ChatPromptAlert
 * @property {string}                       text    내용
 * @property {string}                       value   분류
 */

/**
 * @param {ChatPromptAlert|undefined} alert
 * @returns {ChatPromptAlert}
 */
export function initChatPromptAlert(alert = {}) {
    return {
        ...(alert || {}),

        text: alert?.text ?? null,
        value: alert?.value ?? `${Math.random().toFixed(16)}`.slice(2),
    };
}

/**
 * @typedef ChatPromptGroup
 * @property {string}                       text    표기
 * @property {string}                       value   인덱스
 */

/**
 * @param {ChatPromptGroup|undefined} group
 * @returns {ChatPromptGroup}
 */
export function initChatPromptGroup(group = {}) {
    return {
        ...(group || {}),

        text: group?.text ?? null,
        value: group?.value ?? `${Math.random().toFixed(16)}`.slice(2),
    };
}

/**
 * @typedef CommonSetting__OpenAI
 * @property {boolean}                      enabled         활성화 여부
 * @property {string}                       organization    Organization ID
 * @property {string}                       project         Project ID
 * @property {string}                       apiKey          API Key
 */

/**
 * @param {CommonSetting__OpenAI|undefined} openai
 * @returns {CommonSetting__OpenAI}
 */
function initSetting__OpenAI(openai = {}) {
    return {
        ...(openai || {}),

        enabled: openai?.enabled ?? false,
        organization: openai?.organization || null,
        project: openai?.project || null,
        apiKey: openai?.apiKey || null,
    };
}
